import type { SubscriptionTier } from '@/lib/types';
import { logAnalyticsEvent } from '@/lib/firebase/analytics';

interface PlanToggleProps {
  selected: SubscriptionTier;
  onSelect: (tier: SubscriptionTier) => void;
}

export function PlanToggle({ selected, onSelect }: PlanToggleProps) {
  const handleSelect = (tier: SubscriptionTier) => {
    if (tier !== selected) {
      logAnalyticsEvent('plan_select', { plan: tier });
    }
    onSelect(tier);
  };

  return (
    <div className="flex gap-2 p-1 bg-gray-100 rounded-lg">
      <button
        onClick={() => handleSelect('pro')}
        className={`flex-1 px-4 py-2 rounded-md font-medium transition-colors ${
          selected === 'pro'
            ? 'bg-black text-white'
            : 'bg-transparent text-gray-700 hover:text-gray-900'
        }`}
      >
        Pro
      </button>
      <button
        onClick={() => handleSelect('max')}
        className={`flex-1 px-4 py-2 rounded-md font-medium transition-colors ${
          selected === 'max'
            ? 'bg-black text-white'
            : 'bg-transparent text-gray-700 hover:text-gray-900'
        }`}
      >
        Max
      </button>
    </div>
  );
}
